// extracted by mini-css-extract-plugin
export var companyName = "index-module--companyName--bdf6e";
export var logoArea = "index-module--logoArea--f6cda";
export var navArea = "index-module--navArea--d858e";
export var navList = "index-module--navList--b5c71";
export var root = "index-module--root--91513";